var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14715 0.0224609L4.61485 2.55476H6.51408V5.72013H3.34871V3.82091L0.816406 6.35321L3.34871 8.88551V6.98628H6.51408V10.1517H4.61485L7.14715 12.684L9.67945 10.1517H7.78023V6.98628H10.9456V8.88551L13.4779 6.35321L10.9456 3.82091V5.72013H7.78023V2.55476H9.67945L7.14715 0.0224609Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrag);
export default __webpack_public_path__ + "static/media/drag.9129c0ada7ade6531804eb12e6d72e67.svg";
export { ForwardRef as ReactComponent };